module.exports = __webpack_public_path__ + "img/signup.d56e5b2a.jpg";